/**
 * Returns the abbreviation (e.g. `EST`, `PDT`) for the timezone the browser
 * is currently running in, as of {@link date}.
 */
export function getTimezoneAbbreviation(date: Date): string {
  return (
    date
      .toLocaleTimeString('en-US', { timeZoneName: 'short' })
      .split(' ')
      .pop() ?? ''
  );
}
